if (!customElements.get('custom-product-set-multicolumn')) {
  customElements.define(
    'custom-product-set-multicolumn',
    class CustomProductSetMulticolumn extends HTMLElement {
      constructor() {
        super();
        this.toggleSelector = '[data-custom-product-set-card-media-toggle]';
        this.coarsePointerQuery = window.matchMedia('(hover: none), (pointer: coarse)');
        this.onClick = this.onClick.bind(this);
        this.onPointerModeChange = this.onPointerModeChange.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);

        if (typeof this.coarsePointerQuery.addEventListener === 'function') {
          this.coarsePointerQuery.addEventListener('change', this.onPointerModeChange);
        } else if (typeof this.coarsePointerQuery.addListener === 'function') {
          this.coarsePointerQuery.addListener(this.onPointerModeChange);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);

        if (typeof this.coarsePointerQuery.removeEventListener === 'function') {
          this.coarsePointerQuery.removeEventListener('change', this.onPointerModeChange);
        } else if (typeof this.coarsePointerQuery.removeListener === 'function') {
          this.coarsePointerQuery.removeListener(this.onPointerModeChange);
        }
      }

      isTouchOrCoarsePointer() {
        return this.coarsePointerQuery.matches;
      }

      setFlippedState(toggleEl, isFlipped) {
        toggleEl.classList.toggle('is-flipped', isFlipped);
        toggleEl.setAttribute('aria-pressed', isFlipped ? 'true' : 'false');
      }

      clearFlippedStates() {
        this.querySelectorAll(`${this.toggleSelector}.is-flipped`).forEach((toggleEl) => {
          this.setFlippedState(toggleEl, false);
        });
      }

      onClick(event) {
        const toggleEl = event.target.closest(this.toggleSelector);
        if (!toggleEl || !this.contains(toggleEl)) return;

        if (!this.isTouchOrCoarsePointer()) return;

        event.preventDefault();
        const isFlipped = toggleEl.getAttribute('aria-pressed') === 'true';
        this.setFlippedState(toggleEl, !isFlipped);
      }

      onPointerModeChange() {
        if (!this.isTouchOrCoarsePointer()) {
          this.clearFlippedStates();
        }
      }
    }
  );
}
